import * as React from 'react';
import { useState } from 'react';
import MeddiDiabetesCreate from './MeddiDiabetesCreate';
import { HealthPlanUser } from '../../../graphql/graphql';
import HealthPlanWrapperContainer from '../HealthPlanWrapper/HealthPlanWrapperContainer';
import HealthPlanWrapperCollapse from '../HealthPlanWrapper/HealthPlanWrapperCollapse';
import HealthPlanModal from '../../../Modules/HealthPlan/Components/HealthPlanModal';
import OverlayLoading from '../../OverlayLoading';
import useScope from '../../../Modules/Scope/Hooks/useScope';

interface MeddiDiabetesHealthPlanProps {
	patientId: string;
	healthPlanUser: HealthPlanUser;
	reFetchHealthPlanUser: () => void;
}

const MeddiDiabetesHealthPlan: React.FC<MeddiDiabetesHealthPlanProps> = ({
	patientId,
	healthPlanUser,
	reFetchHealthPlanUser,
}) => {
	const { isLatam } = useScope();
	const [isLoading, setIsLoading] = useState(true);

	//AFTER SUCCESS RELOAD TABS
	const handleCreateSuccess = async (): Promise<void> => {
		await reFetchHealthPlanUser();
	};

	//IF HEALTH PLAN USER IS READY
	if (healthPlanUser?.ready) {
		return (
			<>
				<HealthPlanWrapperContainer
					modalComponent={HealthPlanModal}
					modalItems={13}
					modalItemPrefix='diabetes.infoModal.items'
					modalTitle={'diabetes.infoModal.title'}
					modalDescription='diabetes.infoModal.text2'
					modalSubtitle='diabetes.infoModal.subtitle'
					wrapperCollapseTitle={
						isLatam ? 'diabetes.healthPlan.wrapperCollapseTitle' : undefined
					}
					wrapperCollapse={HealthPlanWrapperCollapse}
					setIsLoading={setIsLoading}
					patientId={patientId}
					showContinue={false}
					healthPlanUser={healthPlanUser}
				/>
				{isLoading && <OverlayLoading />}
			</>
		);
	}

	//IF HEALTH PLAN USER IS NOT READY
	return (
		<MeddiDiabetesCreate
			patientId={patientId}
			healthPlanUser={healthPlanUser}
			onSuccess={handleCreateSuccess}
		/>
	);
};

export default MeddiDiabetesHealthPlan;
